import { Component } from 'react';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import SetSubscriptionsActionDetail from 'automation-ui-action-features/deprecated/set-subscriptions/SetSubscriptionsActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @deprecated Built-in action migrated to Actions API. Keeping around for
 * backwards compatibility.
 */
class SetSubscriptionsActionHistoryCard extends Component {
  render() {
    const {
      actionMetadata,
      actionLabel
    } = this.props;
    return /*#__PURE__*/_jsx(LogEventRowAction, {
      title: actionLabel,
      content: /*#__PURE__*/_jsx(SetSubscriptionsActionDetail, {
        actionMetadata: actionMetadata
      })
    });
  }
}
export default SetSubscriptionsActionHistoryCard;